import { useMutation, type UseMutationResult, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import type { DocumentDto, ManualLoadDocumentDto } from '../../generated/client';
import { updateDocument } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateDocument = (): UseMutationResult<DocumentDto, AxiosError, DocumentDto> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (document) => {
            const enFile = document.documentFiles?.find((f) => f.language === 'EN')?.file as File;
            const deFile = document.documentFiles?.find((f) => f.language === 'DE')?.file as File;
            const frFile = document.documentFiles?.find((f) => f.language === 'FR')?.file as File;
            const itFile = document.documentFiles?.find((f) => f.language === 'IT')?.file as File;

            return updateDocument({
                path: { id: document.id },
                body: {
                    document: new Blob([JSON.stringify(document)], { type: 'application/json' }) as unknown as ManualLoadDocumentDto,
                    enFile,
                    deFile,
                    frFile,
                    itFile,
                },
            }).then((result) => result.data!);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.documents() });
            showSuccessToast(t('successActionGeneric'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
